<template>
  <span :style="wrapperStyle"></span>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 16 },
    color: { type: String, default: '' },
    spin: { type: Boolean, default: false }
  },
  data() { return { loadError: false } },
  computed: {
    wrapperStyle() {
      const size = typeof this.size === 'number' ? this.size : parseInt(this.size) || 16
      const svgUrl = this.getSvgSrc()
      const bgColor = this.color || 'currentColor'

      // 使用background-image + mask来显示SVG并控制颜色
      return `display:inline-block;width:${size}px;height:${size}px;verticalAlign:middle;background-color:${bgColor};-webkit-mask:url(${svgUrl}) no-repeat center/contain;mask:url(${svgUrl}) no-repeat center/contain;`
    }
  },
  methods: {
    getSvgSrc() {
      try { return require(`../../assets/svg/${this.name}.svg`) }
      catch (e) { try { return require(`@/assets/svg/${this.name}.svg`) } catch (e2) { return '' } }
    },
    handleError() { this.loadError = true }
  }
}
</script>